/**
 * Fichier de base contenant les utilitaires fondamentaux
 * et l'initialisation globale
 */

import { csrfHeaders } from './csrf.js';

/**
 * Utilitaire pour naviguer vers une URL avec gestion du hash
 * @param {string} href - L'URL de destination
 * @param {string} hash - Le hash optionnel
 */
export function goto(href, hash) {
    const previous = window.location.href;

    window.location = href;

    if (hash) {
        window.location.hash = hash;
    } else {
        window.location.hash = '#';
    }

    if (window.location.href === previous) {
        window.location.reload();
    }
}

/**
 * Trouve un lien dans un tableau de liens par sa relation
 * @param {Array} links - Tableau de liens
 * @param {string} rel - Relation recherchée
 * @returns {string|undefined} L'URL du lien trouvé
 */
export function findLink(links, rel) {
    for (let i = 0, max = links.length; i < max; i++) {
        if (links[i].rel === rel) {
            return links[i].target;
        }
    }
}

/**
 * Classe de base pour gérer l'upload de fichiers
 */
export class Upload {
    constructor(url, files) {
        this.url = url;
        this.files = Array.isArray(files) ? files : Array.from(files);

        // Callbacks personnalisables
        this.onProgress = function (event) { };
        this.onLoad = function (event) { };
        this.onError = function (event) { };
        this.onAbort = function (event) { };
        this.onFinally = function () { };
    }

    run() {
        if (this.files.length > 0) {
            const xhr = new XMLHttpRequest();

            xhr.upload.addEventListener('progress', e => {
                this.onProgress(e);
            }, false);

            xhr.addEventListener('load', e => {
                this.onLoad(e);
                this.run();
            }, false);

            xhr.addEventListener('error', e => {
                this.onError(e);
                this.run();
            }, false);

            xhr.addEventListener('abort', e => {
                this.onAbort(e);
                this.run();
            }, false);

            xhr.open('post', this.url);
            csrfHeaders(this.url).forEach((value, name) => xhr.setRequestHeader(name, value));

            const formData = new FormData();
            formData.append('file', this.files.pop());

            xhr.send(formData);
        } else {
            this.onFinally();
        }
    }
}

/**
 * Logger conditionnel basé sur la configuration
 */
export const logger = {
    debug: (...args) => {
        if (window.HYPERIO_CONFIG?.options?.debug) {
            console.log('[Hyperio Debug]', ...args);
        }
    },
    info: (...args) => console.log('[Hyperio]', ...args),
    warn: (...args) => console.warn('[Hyperio]', ...args),
    error: (...args) => console.error('[Hyperio]', ...args)
};

/**
 * Initialisation globale au chargement du DOM
 */
document.addEventListener('DOMContentLoaded', function () {
    logger.info('Hyperio webapp assets initialized');

    // Configuration de l'éditeur HTML par défaut
    document.execCommand("defaultParagraphSeparator", false, "p");
}, false);
